import { IDoctor, IDoctorWithId } from '@dokucoach/common-types';
import * as yup from 'yup';

export enum OrderType {
  MEDICATION = 'MEDICATION',
  WOUND_THERAPY = 'WOUND_THERAPY',
  GENERAL = 'GENERAL',
}

export const UpdateOrderSchema = yup.object({
  deliveredAt: yup.date().nullable(),
  orderedAt: yup.date().nullable(),
  id: yup.string().required(),
  doctor: yup.string().nullable(),
  doctorId: yup.string().nullable(),
  note: yup.string().nullable(),
  packageSize: yup.string().nullable(),
});

export interface IOrder {
  id: string;
  orderedAt: Date | null;
  createdAt?: Date | null;
  deliveredAt: Date | null;
  doctor: IDoctor;
  note: string | null;
  order: string;
  discriminator: OrderType;
}

export interface IOrderWithDoctorId {
  id: string;
  orderedAt: Date | null;
  createdAt?: Date | null;
  deliveredAt: Date | null;
  doctor: IDoctorWithId;
  note: string | null;
  order: string;
  discriminator: OrderType;
}

export interface IUpdateOrder {
  id: string;
  orderedAt?: Date | null;
  deliveredAt?: Date | null;
  doctor?: string | null;
  doctorId?: string | null;
  note?: string | null;
  packageSize?: string | null;
  type?: OrderType | null;
}
